import React from 'react';

import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    Text: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

function ArrowButton({
    className = '',
    Text = '',
    title = '',
    onClick = () => {},
    disabled = false,
}) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={className}
        title={title}
        disabled={disabled}
      >
        {Text}
      </button>
    );
}

ArrowButton.propTypes = propTypes;

export default ArrowButton;
